import { memo, useState } from "react";
import { styled } from "@mui/material/styles";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { COMMON_COMPONENT_NAMES } from "constants/flowDesigner";
import { stringifyWithSpaces } from "helpers/common";
import { TimelineEditor } from "cxfcomponents/Timeline/TimelineItem/Editor";
import CopyButton from "cxfcomponents/Timeline/TimelineItem/CopyButton";
import { WrapButton } from "cxfcomponents/Timeline/TimelineItem/WrapButton";

const CopyButtonWrapper = styled(SoftBox)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}));

const ItemDescription = ({ item }) => {
  const [isWrapped, setIsWrapped] = useState(false);

  const handleWrapResult = (e) => {
    e.stopPropagation();

    setIsWrapped((prev) => !prev);
  };

  const generateCodeComponentConsoleLogs = () => {
    if (!item.console_logs || item.console_logs.length === 0) return null;

    return (
      <SoftBox>
        <CopyButtonWrapper>
          <SoftTypography variant="button" fontWeight="regular" color="text">
            Console logs:
          </SoftTypography>
          <div style={{ display: "flex", alignItems: "center" }}>
            <WrapButton isWrapped={isWrapped} handleWrapResult={handleWrapResult} />
            <CopyButton value={stringifyWithSpaces(item.console_logs)} />
          </div>
        </CopyButtonWrapper>

        <SoftBox>
          <TimelineEditor
            defaultValue={stringifyWithSpaces(item.console_logs)}
            isWrapped={isWrapped}
          />
        </SoftBox>
      </SoftBox>
    );
  };

  return (
    <>
      <SoftBox>
        <SoftTypography variant="button" fontWeight="regular" color="text">
          Component: {item.component}
        </SoftTypography>
      </SoftBox>
      <SoftBox>
        <SoftTypography variant="button" fontWeight="regular" color="text">
          Key: {item.componentKey}
        </SoftTypography>
      </SoftBox>
      {/* <SoftBox>
        <SoftTypography variant="button" fontWeight="regular" color="text">
          Action: {item.action}
        </SoftTypography>
      </SoftBox> */}
      <SoftBox>
        <SoftTypography variant="button" fontWeight="regular" color="text">
          Duration: {item.duration > 0 ? ((item.duration % 60000) / 1000).toFixed(3) : "< 0.001"}{" "}
          sec
        </SoftTypography>
      </SoftBox>
      {item.component === COMMON_COMPONENT_NAMES.CODE || item.console_logs?.length
        ? generateCodeComponentConsoleLogs()
        : null}
    </>
  );
};

export default memo(ItemDescription);
